import { module } from 'angular';
import mailFormInputMatchTemplate from './mail-form-input-match.html';

export default module('app')
	.run(/* @ngInject */ (/** @type {import('angular').ITemplateCacheService} */ $templateCache) => {
		$templateCache.put('mail-form-input-match.html', mailFormInputMatchTemplate);
	});
